import { Inject, Injectable, Optional, Type } from '@angular/core';
import { CHANGE_EVENT_COMMAND_HANDLER, Handler } from './change-event-command';
import { CellValueChangedEvent } from 'ag-grid-community';

@Injectable()
export class ChangeEventCommandServiceFactory {
  constructor(@Optional() @Inject(CHANGE_EVENT_COMMAND_HANDLER) private handlers?: Handler<CellValueChangedEvent>[]) {}

  getHandler(handler: Type<Handler>): Handler<CellValueChangedEvent> {
    return this.handlers.find(h => h instanceof handler);
  }
}
